import { Roles } from "@/models/user/roles";
import { GlobalContext, GlobalMutations } from "./types";

export const addLoading = (context: GlobalContext, value: boolean) => {
  context.commit(GlobalMutations.SetLoading, value);
};

export const addLoggedIn = (context: GlobalContext, value: boolean) => {
  context.commit(GlobalMutations.SetLoggedIn, value);
};

export const addRole = (context: GlobalContext, value: Roles | null) => {
  context.commit(GlobalMutations.SetRole, value);
};

export const addMobile = (context: GlobalContext, value: boolean) => {
  context.commit(GlobalMutations.SetMobile, value);
};

export const addTablet = (context: GlobalContext, value: boolean) => {
  context.commit(GlobalMutations.SetTablet, value);
};

export const addMultiplier = (context: GlobalContext, value: number) => {
  if (value === 0) {
    context.commit(GlobalMutations.SetMultiplier, 1);
  } else {
    context.commit(GlobalMutations.SetMultiplier, value);
  }
};
